import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import NumAbbr from "number-abbreviate";
import numeral from "numeral";

var numAbbr = new NumAbbr();

const styles = theme => ({
    card: {
        display: "flex",
    },
    details: {
        display: "flex",
        flexDirection: "column",
    },
    content: {
        flex: "1 0 auto",
    },
    cover: {
        width: 151,
    },
    controls: {
        display: "flex",
        alignItems: "center",
        paddingLeft: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

class countWidget extends Component {

    render() {
        const {classes} = this.props;
        const {uCount, mCount, ipgTot, ipgCom} = this.props;

        return (

            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="flex-start"
                spacing={16}
            >
                <Grid item>
                    <Card className={classes.card}>
                        <div className={classes.details}>
                            <CardContent className={classes.content}>
                                <Typography component="h5" variant="h5">
                                    App Users
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {uCount}
                                </Typography>
                            </CardContent>
                        </div>
                    </Card>
                </Grid>

                <Grid item>
                    <Card className={classes.card}>
                        <div className={classes.details}>
                            <CardContent className={classes.content}>
                                <Typography component="h5" variant="h5">
                                    Merchants
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {mCount}
                                </Typography>
                            </CardContent>
                        </div>
                    </Card>
                </Grid>

                <Grid item>
                    <Card className={classes.card}>
                        <div className={classes.details}>
                            <CardContent className={classes.content}>
                                <Typography component="h5" variant="h5">
                                    IPG Volume
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {/*{new Intl.NumberFormat('en-IN').format(ipgTot)}*/}
                                    {/*{numAbbr.abbreviate(ipgTot, 2)}*/}
                                    {"Rs. "+numeral(ipgTot).format("Rs0,0.00 a")}
                                </Typography>
                            </CardContent>
                        </div>
                    </Card>
                </Grid>

                <Grid item>
                    <Card className={classes.card}>
                        <div className={classes.details}>
                            <CardContent className={classes.content}>
                                <Typography component="h5" variant="h5">
                                    IPG Commission Volume
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {/*{new Intl.NumberFormat('en-IN').format(ipgCom)}*/}
                                    {"Rs. "+numeral(ipgCom/100).format("Rs0,0.00")}
                                </Typography>
                            </CardContent>
                        </div>
                    </Card>
                </Grid>

            </Grid>
        );
    }
}

countWidget.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(countWidget);